import FieldSelector from './src/fieldselector.vue';

FieldSelector.install = function (Vue) {
    Vue.component(FieldSelector.name, FieldSelector);
};

export default FieldSelector;